import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_ctx.failures.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.failures, (failure, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "d-flex align-baseline mt-1 text-caption text-warning"
          }, [
            _createVNode(_component_v_icon, {
              size: "x-small",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("mdi-alert-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(_ctx.text(failure)), 1)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}